import * as React from 'react';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';

export default function ProductFilter({controllersList, onClickChangeList,selectedControllerId}) {
  // const [value, setValue] = React.useState('');

  // const handleChange = (val) => {
  //   setValue(val);
  //   onClickChangeList(val);
  // };

  return (

    <><Box 
    className="productFilters"
    sx={{
      maxWidth: 900,
      marginBottom: 2,
      paddingBottom: '5px',
      overflowX: 'auto',
      "&::-webkit-scrollbar": {
        height: '4px',
        width: '4px',
        background: 'gray',
      },
      "&::-webkit-scrollbar-track": {
        background: '#f1f1f1'
      },
      "&::-webkit-scrollbar-thumb": {
        background: '#888'
      },
      "&::-webkit-scrollbar-thumb:hover": {
        background: 'rgb(30,60,114)'
      },
      "&::-webkit-scrollbar-thumb:horizontal": {
        borderRadius: '10px'
      },
      
    }}>
        <Stack direction="row" spacing={2}>
          {controllersList?.map((row, i) => (
            <Chip key={row.id}  className={selectedControllerId === row.id ? 'filterActive' : ''}  label={row.controller_name} onClick={(e) => onClickChangeList(row.id)} />
          ))}
        </Stack>
      </Box></>
  );
}
